export enum ShiftsLegendColorTypes {
    plannedFull = 'planned-full',
    plannedOpen = 'planned-open',
    conceptFull = 'concept-full',
    conceptOpen = 'concept-open',
    selected = 'selected',
    companyMedic = 'company-medic',
    pastShift = 'past-shift',
}
